// src/utils/slugs.ts

/**
 * Convert text to URL-safe slug
 * @example slugify("Ice Hockey") → "ice-hockey"
 * @example slugify("") → ""
 * @example slugify(null) → ""
 */
export function slugify(text: string): string {
  if (!text) {
    return "";
  }

  return text
    .toLowerCase()
    .replace(/ø/g, "o")
    .replace(/æ/g, "ae")
    .replace(/ð/g, "d")
    .replace(/þ/g, "th")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[\u0020-\u002f\u003a-\u0060\u007b-\u02ff\u0370-\uffff]+/gu, "-")
    .replace(/^-|-$/g, "");
}

/**
 * Convert slug back to title case
 * @example deslugify("ice-hockey") → "Ice Hockey"
 * @example deslugify("") → ""
 * @example deslugify(null) → ""
 */
export function deslugify(slug: string): string {
  if (!slug) {
    return "";
  }

  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * Convert an activity route slug back to its activity key (lowercase,
 * underscores), the form stored in the `activities`/`activity_types` fields.
 * @example activitySlugToKey("dancing-and-cheer") → "dancing_and_cheer"
 * @example activitySlugToKey("football") → "football"
 */
export function activitySlugToKey(slug: string | null | undefined): string {
  if (!slug) {
    return "";
  }

  return slug.toLowerCase().replace(/-/g, "_");
}
